'use client';

import { Link, Icon, Button } from '@theme/components';
import { useSession } from 'next-auth/react';
import { ROUTES } from '@theme/routes';

import { useLocalization, useMediaQuery } from '@akinon/next/hooks';
import { Drawer } from '@theme/components/bw/drawer';
import { useState } from 'react';
import AccountMenu from '../account/account-menu';

export const UserMenu = ({ className }: { className?: string }) => {
  const { status } = useSession();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const { t } = useLocalization();

  return (
    <>
      {isMobile ? (
        <>
          {status === 'authenticated' ? (
            <button onClick={() => setDrawerOpen(true)}>
              <Icon name="y-user" size={32} />
            </button>
          ) : (
            <Link href={ROUTES.AUTH} className={className}>
              <Icon name="y-user" size={32} />
            </Link>
          )}
        </>
      ) : (
        <Link
          href={
            status === 'authenticated' ? ROUTES.ACCOUNT_ORDERS : ROUTES.AUTH
          }
          className={className}
        >
          <Icon name="y-user" size={32} />
        </Link>
      )}
      <Drawer
        portalId="user-account-menu-drawer"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        HeaderComponent={
          <div className="flex justify-between items-center px-5 py-3 border-b border-gray-250">
            <div className="flex items-center gap-2">
              <Icon
                name="chevron-left"
                size={24}
                className="cursor-pointer"
                onClick={() => setDrawerOpen(false)}
              />
              <h2 className="text-xl font-semibold">
                {t('account.base.menu.my_account')}
              </h2>
            </div>
            <button onClick={() => setDrawerOpen(false)}>
              <Icon name="y-close" size={16} className="p-1" />
            </button>
          </div>
        }
      >
        <AccountMenu />
      </Drawer>
    </>
  );
};
